import {
  Box,
  Button,
  Container,
  Group,
  LoadingOverlay,
  Paper,
  Title,
  useMantineTheme
} from '@mantine/core'
import { IconHeadsetOff, IconPlus } from '@tabler/icons'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { TicketDrawer } from '@/containers/navigation/TicketMenu'
import { useFetch } from '@/lib/hooks'
import { getUrlString } from '@/lib/utils'
import { SiteData as SiteDataType } from '@/types'

import TicketsList from './components/TicketsList'

interface Props {
  initialData?: SiteDataType
}

export default function TicketsView({ initialData }: Props) {
  // Hooks
  const router = useRouter()
  const theme = useMantineTheme()

  // Constants
  const { seller, site } = router.query || {}
  const siteSlug = getUrlString(site)

  // States
  const [open, setOpen] = useState<boolean>(false)
  const [query, setQuery] = useState({
    page: 1,
    page_size: 25,
    ordering: '-date_updated'
  })

  // Fetch
  const { data: siteData } = useFetch([siteSlug ? `/${siteSlug}/` : null], {
    fallbackData: initialData?.site
  })
  const { data: ticketsData } = useFetch([siteSlug ? `/${siteSlug}/support/tickets/` : null, query])

  // Effect
  useEffect(() => {
    if (seller && seller !== '') {
      setOpen(true)
    }
  }, [seller])

  if (!siteData) return <LoadingOverlay visible />

  return (
    <Container px="xs" py="lg" size="xl">
      <Group mb="md" spacing={0} position="apart">
        <Title order={2}>Atendimentos</Title>

        <Button leftIcon={<IconPlus />} onClick={() => setOpen(true)}>
          Abrir Atendimento
        </Button>
      </Group>

      {!!ticketsData && ticketsData?.results?.length > 0 ? (
        <TicketsList
          count={ticketsData?.count}
          page={query?.page}
          pageSize={query?.page_size}
          tickets={ticketsData.results}
          handleQuery={currentPage =>
            setQuery((prevQuery: any) => ({ ...prevQuery, page: currentPage }))
          }
        />
      ) : (
        <Paper p="xl" withBorder sx={{ textAlign: 'center' }}>
          <IconHeadsetOff size={50} color={theme.colors.yellow[5]} />
          <Box mb={3} />
          <Title order={5} align="center">
            Você ainda não possui nenhum atendimento...
          </Title>
        </Paper>
      )}

      <TicketDrawer
        open={open}
        handleClose={() => setOpen(false)}
        siteData={siteData}
        searchQuery={query}
      />
    </Container>
  )
}
